import React from "react";
import Nav from "../Components/Nav";
import CarouselProduct from "../Components/CarouselProduct";
import Products from "../Components/Products";
import Footer from "../Components/Footer";
import { useTranslation } from "react-i18next";

export default function WasteRecycle() {
    const { t } = useTranslation();
    return (
        <div className="wasteRecycle">
            <Nav/>
            <CarouselProduct title="Wastemaster" isOnly/>
            <div className="component" style={{marginTop: -5}}>
                <div className="container">
                    <div className="left">{t('home.companyTitle')}</div>
                    <div className="right">
                        <p>
                            {t('home.companyDescription1')}
                        </p>
                        <p>
                            {t('home.companyDescription2')}
                        </p>
                        <p>
                            {t('home.companyDescription3')}
                        </p>
                        <p>
                            {t('home.companyDescription4')}
                        </p>
                    </div>
                </div>
            </div>
            <Products/>
            <Footer/>
        </div>
    );
}
